import {createSinglePathSVG} from './TEMPLATE'

export const AlignRight_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 20 20',
  strokeWidth: 1.67,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M17.5 8.33333H6.66667M17.5 5H3.33333M17.5 11.6667H3.33333M17.5 15H6.66667',
})
